import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from '@mui/material';

export default function FormCheckbox({ name, disabled, sublabel, ...other }) {
  const { control } = useFormContext();

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => {
              return (
                <Checkbox
                  {...field}
                  checked={field.value || false}
                  disabled={disabled}
                />
              );
            }}
          />
        }
        {...other}
      />
    </FormGroup>
  );
}

FormCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  sublabel: PropTypes.string,
};

FormCheckbox.defaultProps = {
  disabled: false,
};
